import {
  LOAD_PLANT,
  SHOW_PLANT,
  CREATE_PLANT,
  UPDATE_PLANT,
  DELETE_PLANT,
  IMPORT_PLANT,
  EXPORT_PLANT,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  importResponse: null,
  data: {
    id: "",
    type: "Plant",
    company_id: "",
    province_id: "",
    code: "",
    name: "",
    phone_number: "",
    lat: "",
    lng: "",
    address: "",
    geo_fence: "",
    use_geofence: "N",
    distributor_id: "",
    radius: 100,
    lead_time_days: 1,
    geo_fence_max_lat: 0,
    geo_fence_min_lat: 0,
    geo_fence_max_lng: 0,
    geo_fence_min_lng: 0,
    province_ids: [],
    additional_provinces: [],
  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PLANT.REQUEST:
    case SHOW_PLANT.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false,
      };
    case CREATE_PLANT.REQUEST:
    case UPDATE_PLANT.REQUEST:
    case DELETE_PLANT.REQUEST:
    case EXPORT_PLANT.REQUEST:
    case IMPORT_PLANT.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false,
        importResponse: null,
      };

    case LOAD_PLANT.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_PLANT.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_PLANT.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case UPDATE_PLANT.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_PLANT.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true,
      };

    case IMPORT_PLANT.SUCCESS:
      return {
        ...state,
        success_msg: "import_success",
        loading: false,
        shouldReload: true,
        importResponse: action.payload.data,
      };

    case EXPORT_PLANT.SUCCESS:
      return {
        ...state,
        success_msg: "export_success",
        loading: false,
      };

    case LOAD_PLANT.FAILURE:
    case SHOW_PLANT.FAILURE:
    case CREATE_PLANT.FAILURE:
    case UPDATE_PLANT.FAILURE:
    case DELETE_PLANT.FAILURE:
    case IMPORT_PLANT.FAILURE:
    case EXPORT_PLANT.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false,
      };

    default:
      return state;
  }
};
